import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import utils from 'helpers/utils'
import AuthTemplate from 'components/templates/AuthTemplate'
import { LinearProgress } from '@mui/material'
import queryString from 'query-string'
import useShowError from 'hooks/useShowError'
import axios from 'providers/axios'
import useEffectOnce from 'hooks/useEffectOnce'
import images from 'assets/images'
import { URL_APP } from 'helpers/config'
import { LinkedInStateObject } from 'helpers/integrations/linkedin'

const AuthLinkedin = () => {
  const showError = useShowError()
  const navigate = useNavigate()
  const [message, setMessage] = React.useState('Loading...')
  const [loading, setLoading] = React.useState(true)
  const location = useLocation()
  const parsed = queryString.parse(location.search)

  useEffectOnce(() => {
    try {
      if (parsed.error && parsed.error_description) throw new Error(parsed.error_description as string)
      if (!parsed.code) throw new Error('No code')
      const state = JSON.parse(parsed.state as string) as LinkedInStateObject
      const isChromeExtension = state.requester === 'chrome-extension'

      const login = async () => {
        try {
          const { data } = await axios.post('/linkedin/login', {
            code: parsed.code,
            authDevice: utils.getFullAuthDeviceData(),
            redirectUrl: state.redirectUrl,
          })
          if (!data) throw new Error('No data')
          utils.setChromeExtension(data.authDevice.deviceToken)
          setLoading(false)
          setMessage('Success!')

          if (isChromeExtension) return

          window.location.href = data.redirectUrl
        } catch (e) {
          showError(e)
          navigate('/login')
        }
      }

      const signUp = async () => {
        try {
          const { data } = await axios.post('/linkedin/sign-up', {
            code: parsed.code,
            authDevice: utils.getFullAuthDeviceData(),
            productId: state.productId,
            overrideDefaultSignupAction: state.overrideDefaultSignupAction,
          })
          if (!data) throw new Error('No data')
          utils.setChromeExtension(data.authDevice.deviceToken)
          setLoading(false)
          setMessage('Success!')

          if (isChromeExtension) return

          window.location.href = URL_APP
        } catch (e) {
          showError(e)
          navigate('/signup')
        }
      }

      if (state.action === 'LOGIN') login()
      if (state.action === 'SIGNUP') signUp()
    } catch (error) {
      showError(error)
    }
  })

  return (
    <AuthTemplate>
      <div className="tac">
        <img alt="Linkedin logo" style={{ width: '40%', maxWidth: '250px' }} src={images.LINKEDIN_PAGE_LOGO} />
        {loading && <LinearProgress sx={{ my: '40px', maxWidth: '400px', mx: 'auto' }} />}
        <p>{message}</p>
      </div>
    </AuthTemplate>
  )
}

export default AuthLinkedin
